/**
 * API client per la configurazione dell'applicazione.
 *
 * Mostra:
 * - ESSENTIAL configs (da .env, non modificabili)
 * - RUNTIME configs (da app_config DB, modificabili)
 *
 * Endpoints:
 * - GET /api/v1/config - Lista tutte configurazioni
 * - GET /api/v1/config/{key} - Config specifica
 * - PUT /api/v1/config/{key} - Aggiorna runtime config
 * - PUT /api/v1/config/bulk - Aggiorna multiple
 * - POST /api/v1/config/reset/{key} - Reset a default
 */

import api from './api';

export interface ConfigItem {
  key: string;
  value: string;
  type: string;
  description: string | null;
  source: string;  // "essential" or "runtime"
  editable: boolean;
}

export interface ConfigUpdate {
  value: string;
}

export const configApi = {
  /**
   * Lista tutte le configurazioni (essential + runtime).
   */
  list: async (): Promise<ConfigItem[]> => {
    const response = await api.get<ConfigItem[]>('/config');
    return response.data;
  },

  /**
   * Ottieni una configurazione specifica.
   */
  get: async (key: string): Promise<ConfigItem> => {
    const response = await api.get<ConfigItem>(`/config/${key}`);
    return response.data;
  },

  /**
   * Aggiorna una configurazione runtime.
   */
  update: async (key: string, data: ConfigUpdate): Promise<ConfigItem> => {
    const response = await api.put<ConfigItem>(`/config/${key}`, data);
    return response.data;
  },

  /**
   * Aggiorna multiple configurazioni runtime.
   */
  bulkUpdate: async (configs: Record<string, string>): Promise<ConfigItem[]> => {
    const response = await api.put<ConfigItem[]>('/config/bulk', { configs });
    return response.data;
  },

  /**
   * Reset a runtime config to default value.
   */
  reset: async (key: string): Promise<ConfigItem> => {
    const response = await api.post<ConfigItem>(`/config/reset/${key}`);
    return response.data;
  },
};